import { useMediaQuery, useTheme } from '@mui/material'
import { useCallback } from 'react'
import { GUI_LIVE_VIEW_BREAKPOINT_360, GUI_LIVE_VIEW_BREAKPOINT_XS, GUI_LIVE_VIEW_BREAKPOINT_XXS } from 'src/Libs/live-view/utils/breakpoints'

/**
 * Hook to provide a function that returns different values based on GuiLiveView breakpoints.
 */
export const useResponsiveHelpers = (): ((
  xxsValue: number | string,
  xsValue: number | string,
  upXsValue: number | string,
  upMd?: number | string,
  between360AndXsValue?: number | string
) => string | number) => {
  const theme = useTheme()
  const isXsLiveView = useMediaQuery(theme.breakpoints.between(GUI_LIVE_VIEW_BREAKPOINT_XXS, GUI_LIVE_VIEW_BREAKPOINT_XS))
  const isBetween360AndXsLiveView = useMediaQuery(theme.breakpoints.between(GUI_LIVE_VIEW_BREAKPOINT_360, GUI_LIVE_VIEW_BREAKPOINT_XS))
  const isUpXsLiveView = useMediaQuery(theme.breakpoints.up(GUI_LIVE_VIEW_BREAKPOINT_XS))
  const isUpMd = useMediaQuery(theme.breakpoints.up('md'))

  return useCallback(
    (
      xxsValue: number | string,
      xsValue: number | string,
      upXsValue: number | string,
      upMd?: number | string,
      between360AndXsValue?: number | string
    ): number | string => {
      if (isUpMd && upMd !== undefined) {
        return upMd
      }

      if (isUpXsLiveView) {
        return upXsValue
      }

      if (isBetween360AndXsLiveView) {
        return between360AndXsValue ?? xsValue
      }

      if (isXsLiveView) {
        return xsValue
      }

      return xxsValue
    },
    [isUpMd, isUpXsLiveView, isBetween360AndXsLiveView, isXsLiveView]
  )
}
